const mutations = { 
  setCategories(state, data) {
    state.categories = data;
  }
}

export default mutations;
  